import React from "react";
import { COLORS } from "styles/colors";
import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";
import styled from "styled-components";

export default function SuspendedLabel({
  status,
}: {
  status: SUSPENSION_STATUS;
}) {
  return (
    <Text
      $color={
        status === SUSPENSION_STATUS.SUSPENDED
          ? COLORS.COMPANY
          : status === SUSPENSION_STATUS.DISABLED
          ? COLORS.VALIDATERED
          : undefined
      }
    >
      {status === SUSPENSION_STATUS.ENABLED
        ? "Enabled"
        : status === SUSPENSION_STATUS.SUSPENDED
        ? "Suspended"
        : "Disabled"}
    </Text>
  );
}
const Text = styled.div<{ $color?: string }>`
  color: ${({ $color }) => $color};
`;
